{
  "app-frame": {
    "buttons": {
      "be-partner": "Dành cho chủ Salon",
      "login": "Đăng nhập",
      "logout": "Đăng xuất",
      "my-appointments": "Lịch hẹn của tôi",
      "my-salons": "Tiệm của tôi",
      "profile": "Hồ sơ cá nhân",
      "read": "Đọc",
      "sign-up": "Đăng ký",
      "top-salons": "Salon hàng đầu"
    },
    "text": {
      "agb-short": "ĐKC",
      "agb-updated-valid-since": "đã được cập nhật và sẽ có hiệu lực từ {{date}}",
      "click-to-read": "Ấn để đọc"
    }
  }
}
